var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'hab-datepicker',
    {
      [`${_vm.className}`]: _vm.className,
      [`theme-${_vm.theme}`]: _vm.theme,
    },
  ]},[_c('div',{staticClass:"datepicker"},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label)),(_vm.required)?_c('span'):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',[_c('date-picker',{attrs:{"type":_vm.type,"clearable":_vm.clearable,"lang":_vm.lang,"format":_vm.format,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"default-value":_vm.defaultValue,"disabled-date":_vm.handleDisableDate,"value":_vm.value},on:{"change":_vm.onChange}})],1)]),_vm._v(" "),(_vm.error)?_c('span',{staticClass:"alert-input-error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }